var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-form',{attrs:{"id":_vm.id,"type":"infographic","plural":"infographics"},model:{value:(_vm.infographic),callback:function ($$v) {_vm.infographic=$$v},expression:"infographic"}})}
var staticRenderFns = []

export { render, staticRenderFns }